import React from 'react';
import Loading from '../Loading';
import avatar from '../../assets/images/avatar-50.png';
import InfiniteScroll from 'react-infinite-scroller';
import MisPicks from './MisPicks';
import styled from 'styled-components';
/**
 * This component renders a list of the standings
 */
const PicksList = ({
  survivorInfo,
  myEntry,
  standings,
  gameStatus,
  survivorWeeks,
  currentWeek,
  fixtures,
  allFixtures,
}) => {
  let userItem = standings.items.map((standing) => {
    // console.log(standing.survivor_picks)
    let picksList = survivorWeeks.map((weekPick) => {
      let currentPick =
        !standing.survivor_picks || !standing.survivor_picks[weekPick.id]
          ? null
          : standing.survivor_picks[weekPick.id];
    
      let isThisWeek = weekPick.id === currentWeek.id;

      if (!currentPick) {
        return (
          <div key={standing.survivor_entry_id + weekPick.id} className="item-container">
            <div className="img-container">
              {isThisWeek && standing.alive ? (
                <div className={`shirt-picks`}>
                  <i className="ion-close" style={{ color: 'rgb(244, 0, 52)' }}></i>
                </div>
              ) : standing.elimination_week_id < weekPick.id ? null : (
                <div className={`shirt-picks underline`}>
                  <i className="ion-close" style={{ color: 'rgb(244, 0, 52)' }}></i>
                  {/*<span>N/D</span>*/}
                </div>
              )}
            </div>
          </div>
        );
      } else {
        // ------
        let pickStatus = '';
      
        const isTiePick = currentPick?.pick === null && (currentPick?.tie === true || currentPick?.tie === 1);

        // If it is a survivor eliminator (Participant picks the losing team)
        // In that case we look up the fixture and invert whether the winner is the losing team or the winning team
        if (survivorInfo.eliminator == 1) {

          const fixture = fixtures.find(fixt => fixt.id === currentPick.fid)

          const winningPick = fixture?.winning_pick;

          if (winningPick === 'tie') {
            currentPick.correct = true;
          } else {
            // Invert the fixture winner because for this survivor, the "winning" team is the one that loses
            const effectiveWinner = winningPick === 'home' ? 'away' : 'home';
            const isPickHome = currentPick.pick === fixture?.home_team?.id;

            currentPick.correct = false;

            if (effectiveWinner === 'home' && isPickHome) {
              currentPick.correct = true;
            } else if (effectiveWinner === 'away' && !isPickHome) {
              currentPick.correct = true;
            }
          }
        }
          
        let tieFixture = null;
    
        if (isTiePick) {
          tieFixture = allFixtures.fixtures[weekPick.id].find(fixt => fixt.id === currentPick.fid)
        }
  
        // st 0 = live
        // st 1 = upcoming
        // st 2 = finished
        // en 0 = disabled - shows only if user has picked or not
        // en 1 = enabled  - shows all picks for all users
        currentPick.elimination = standing.elimination_week_id === weekPick.id;
        // currentPick['eliminated_this_week'] = standing.elimination_week_id === weekPick.id;
        if (!survivorInfo.strikes_enabled) {
          if (currentPick.st !== 1 && currentPick.en && !currentPick.correct) {
            pickStatus = 'perdio';
          }
          if (currentPick.st === 2 && currentPick.en && !currentPick.correct) {
            pickStatus = 'underline perdio';
          }
          if (currentPick.en && currentPick.correct) {
            pickStatus = 'gano';
          }
        } else {
          if (currentPick.en && currentPick.strike && !currentPick.elimination) {
            pickStatus = 'strike';
          }
          if (currentPick.en && currentPick.strike && currentPick.elimination) {
            pickStatus = 'strike underline';
          }
          // live
          if (
            currentPick.st !== 1 &&
            currentPick.en &&
            !currentPick.correct &&
            !currentPick.strike
          ) {
            pickStatus = 'perdio';
          }
          //closed
          if (
            currentPick.st === 2 &&
            currentPick.en &&
            !currentPick.correct &&
            !currentPick.strike
          ) {
            pickStatus = 'underline';
          }
          if (currentPick.en && currentPick.correct) {
            pickStatus = 'gano';
          }
        }

        return (
          <div key={standing.survivor_entry_id + '' + weekPick.id} className="item-container">
            <div className="img-container">
              {currentPick.en === 1 ? (
                <>
                  {isTiePick && (

                    <div className={`shirt-picks ${pickStatus}`} style={{ marginTop: '2px' }}>
                      <TieFlag
                      >
                        E
                      </TieFlag>

                      <small className="team-name" style={{ fontSize: '9px' }}>
                        {tieFixture?.home_team?.abbreviation}
                        {tieFixture?.home_team?.abbreviation && tieFixture?.away_team?.abbreviation
                          ? ' - '
                          : ''}
                        {tieFixture?.away_team?.abbreviation}{' '}
                      </small>
                    </div>
                  )}

                  {!isTiePick && (
                    <div className={`shirt-picks ${pickStatus}`}>
                      <i className={`${currentPick.logo} home helmet`}></i>
                      <small className="team-name">
                        {currentPick.team}{' '}
                        {survivorInfo.point_format === 'line' ? (
                          <span className="linea"> {currentPick.advantage} </span>
                        ) : null}{' '}
                      </small>
                    </div>
                  )}
                </>

              ) : (
                <div className={`shirt-picks ${pickStatus}`}>
                  {currentPick.pick ? (
                    <i className="ion-checkmark" style={{ color: 'rgb(120, 180, 40)' }}></i>
                  ) : (
                    <i className="ion-close-circled" style={{ color: 'rgb(120, 180, 40)' }}></i>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      }
    });

    return (
      <li key={standing.survivor_entry_id} className={`lower-table-item user  `}>
        {picksList}
      </li>
    );
  });
  return <ul className="list-unstyled lower-list">{userItem}</ul>;
};

/**
 * This component renders a list of the standings
 */
const UsersList = ({ standings, myEntry }) => {
  let usersList = standings.items.map((standing) => { 
    // console.log(standing)
    return (
      <ul key={standing.survivor_entry_id} className="list-unstyled lower-list">
        <li
          className={`lower-table-item user ${myEntry !== null && myEntry.id === standing.survivor_entry_id ? 'ownUser' : '' }`}
        >
          <div className="item-container">
            <div className="image-container">
              <img
                className="avatarPicksGrupo"
                src={standing.avatar === '/img/profile-image-01.png' ? avatar : standing.avatar}
              />
            </div>
            <span className="picks-rank"> {standing.rank}°</span>
            <span style={{ fontWeight: 'bold' }}>
              {standing.nick}
              {standing.number !== null ? (
                <sup
                  style={{
                    fontWeight: 'lighter',
                    fontSize: '75%',
                    margin: '0 2px',
                  }}
                >
                  {standing.number}
                </sup>
              ) : (
                ''
              )}
            </span>
          </div>
        </li>
      </ul>
    );
  });

  return (
    <div className="overflow overflow-y overflow-picks-grupo userList sync-vertical">
      {usersList}
    </div>
  );
};

/**
 * This component renders a list of the standings
 */
const AliveList = ({ standings, myEntry }) => {
  let totalesList = standings.items.map((standing) => {
    // console.log(standing)
    return (
      <li
        key={standing.survivor_entry_id}
        className={`lower-table-item ${myEntry !== null && myEntry.id === standing.survivor_entry_id ? 'ownUser' : ''
          }`}
      >
        <div className="item-container">
          <div className="shirt-picks">
            {standing.alive === 1 ? (
              <i className="ion-checkmark" style={{ color: 'rgb(120, 180, 40)' }}></i>
            ) : (
              <i className="ion-close" style={{ color: 'rgb(244, 0, 52)' }}></i>
            )}
          </div>
        </div>
      </li>
    );
  });
  return (
    <ul className="list-unstyled lower-list" style={{ width: '100%' }}>
      {totalesList}
    </ul>
  );
};

class TablaPicksGrupoSurvivor extends React.Component {
  render() {
    // console.log( this.props );
    let conditionalComponent = null;
    if (this.props.dataReady) {
      conditionalComponent = (
        <div className="lista-container">
          <UsersList
            standings={this.props.picksGrupal}
            myEntry={
              this.props.withRegister && this.props.entriesInfo
                ? this.props.entriesInfo.survivor_entry
                : null
            }
          />
          <div className="overflow overflow-y overflow-picks-grupo dataList sync-vertical sync-horizontal">
            <InfiniteScroll
              pageStart={1}
              loadMore={this.props.siguientePag}
              hasMore={
                this.props.picksGrupal && this.props.picksGrupal.pages === this.props.actualPagina
                  ? false
                  : true
              }
              loader={<Loading key={'labelLoader00'} label="..." />}
              useWindow={false}
            >
              {
                <PicksList
                  survivorInfo={this.props.survivorInfo}
                  currentWeek={this.props.currentWeek}
                  standings={this.props.picksGrupal}
                  gameStatus={this.props.survivorInfo.status}
                  survivorTeams={this.props.survivorTeams}
                  survivorWeeks={this.props.survivorWeeks}
                  fixtures={this.props.fixtures}
                  myEntry={this.props.withRegister ? this.props.entriesInfo.survivor_entry : null}
                  allFixtures={this.props.allFixtures}
                />
              }
            </InfiniteScroll>
          </div>
          <div
            className="overflow overflow-y overflow-picks-grupo totalesList sync-vertical"
            style={{ width: '7%' }}
          >
            <AliveList
              standings={this.props.picksGrupal}
              myEntry={this.props.withRegister ? this.props.entriesInfo.survivor_entry : null}
            />
          </div>
        </div>
      );
    } else {
      conditionalComponent = <Loading label="..." />;
    }
    return (
      <div className="tabla-grupos">
        <div className="lower-table border-gradient">
          <div className="row-grupos header font-chivo">
            <div className="lower-table-item user title">
              <span>PICKWINERO</span>
            </div>
            <div
              className="lower-table-item total"
              style={{ justifyContent: 'center', paddingRight: 0 }}
            >
              <span> VIVO </span>
            </div>
          </div>
          <MisPicks
            pointFormat={this.props.survivorInfo.point_format}
            survivorInfo={this.props.survivorInfo}
            survivorFixtures={this.props.fixtures}
            gameStatus={this.props.survivorInfo.status}
            selectedWeek={this.props.selectedWeek}
            currentWeek={this.props.currentWeek}
            withRegister={this.props.withRegister}
            myEntry={this.props.withRegister ? this.props.entriesInfo.survivor_entry : null}
            picksGrupal={this.props.picksGrupal}
            survivorTeams={this.props.survivorTeams}
            survivorWeeks={this.props.survivorWeeks}
            allFixtures={this.props.allFixtures}
          />
          {conditionalComponent}
        </div>
      </div>
    );
  }
}

export default TablaPicksGrupoSurvivor;

export const TieFlag = styled.span`
  font-size: 0.7em;
  width: 22px;
  height: 16px;
  border-radius: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
  font-weight: bold;
  font-size: 10px;
  margin-top: -3px
`
